import * as types from '../constants/actionTypes';
import api from '../../shared/api.json';

export function fetchToggles() {
    return {
        types: [
            types.FETCH_TOGGLES,
            types.FETCH_TOGGLES_SUCCESS,
            types.FETCH_TOGGLES_FAIL,
        ],
        promise: (client) => client.get(api.util.featureToggles),
    };
}
